import { io } from "socket.io-client";
import { BACKEND_URL } from "../Helpers/constant";

const SOCKET_URL = BACKEND_URL;
export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

export default socket;
